import { LandingPage } from '@/features/auth';

export default function WelcomePage() {
  return <LandingPage />;
}
